<template>
  <div>
    <form @submit.prevent="sendTextMessage">
      <div class="mb-4">
        <label for="recipientPhone" class="block text-sm font-medium mb-1">Recipient Phone Number</label>
        <vue-tel-input v-model="phoneNumber"
                       :input-options="{ showDialCode: false, tabindex: false, placeholder: '+1 555 555-5555' }"
                       @input="onPhoneInput">
          <template slot="arrow-icon"> <span
              class="vti__dropdown-arrow">&nbsp;▼</span></template>
        </vue-tel-input>
        <small>Enter the phone number to receive the test message</small>
      </div>
      <div class="mb-4">
        <label for="recipientName" class="block text-sm font-medium mb-1">Recipient's First Name</label>
        <b-input
            id="recipientName"
            v-model="localRecipientName"
            type="text"
            placeholder="Jane"
            required
        />
        <small>Will replace [FirstName] in your text overlay</small>
      </div>
      <b-btn
          class="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 w-100"
          :disabled="isSending || !localRecipientName || !phoneNumber"
          type="submit"
      >
        <i class="uil uil-fast-mail mr-2"></i>
        {{ isSending ? 'Sending...' : 'Send Test Message' }}
      </b-btn>
    </form>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import axios from 'axios';
import 'vue-tel-input/dist/vue-tel-input.css';

export default {
  name: 'TextMessageTester',
  props:{
    imageId:{
      type: String,
      default: null
    }
  },
  data() {
    return {
      showModal: false,
      localRecipientName: '',
      phoneNumber: '',
      isSending: false
    };
  },
  computed: {
    ...mapState('imageEditor',[
      'imagePreview',
      'overlaySettings',
      'recipientName',
      'isGifMode'
    ]),
    user() {
      return this.$store.getters['auth/user']
    },
  },
  methods: {
    ...mapMutations('imageEditor',[
      'SET_RECIPIENT_NAME',
      'SET_IS_SENDING'
    ]),

    async sendTextMessage() {
      if (!this.localRecipientName || !this.phoneNumber) {
        this.error = 'Please fill out all fields';
        return;
      }

      this.error = '';
      this.success = '';
      this.isSending = true;
      this.SET_IS_SENDING(true);

      try {
        // Update store with recipient name
        this.SET_RECIPIENT_NAME(this.localRecipientName);

        // Prepare request data
        const payload = {
          text_content: '',
          first_name: this.localRecipientName,
          phone_number: this.phoneNumber,
        };

        // Send request to server
        await axios.post(`/businesses/test-overlay-text/${this.user.business.id}/${this.imageId}`, payload);

      } catch (error) {

      } finally {
        this.isSending = false;
        this.SET_IS_SENDING(false);
      }
    }
  }
};
</script>
